import {NgModule} from '@angular/core';
import {FileDownloadComponent} from './file-download.component';
import {LoadingModule} from '../loading/loading.module';
import {TranslatePipe, TranslateDirective} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [FileDownloadComponent],
  imports: [
    LoadingModule,
    TranslatePipe, TranslateDirective,
    CommonModule
  ],
  exports: [FileDownloadComponent]
})
export class FileDownloadModule { }
